<template>
  <v-card class="mx-auto" width="90%" style="margin-bottom: 15px;">
    <v-container fluid class="my-5">
      <v-layout row justify-center>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="groupedVotes"
              :items-per-page="10"
              class="elevation-1"
              item-key="id"
              show-expand
              :expanded.sync="expanded"
              @click:row="handleRowClick"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-data-table
                    :headers="subHeaders"
                    :items="item.votes"
                    hide-default-footer
                    class="elevation-0"
                  >
                  <template v-slot:item.userId="{ item }">
                    {{ getUserName(item.userId) }}
                  </template>
                  <template v-slot:item.vote="{ item }">
                    {{ item.vote === 'up' ? '👍' : '👎' }}
                  </template>
                  </v-data-table>
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import numbro from 'numbro'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      expanded: []
    }
  },
  methods: {
    ...mapActions('ai', [
      'fetchDetailedSummaryVotes'
    ]),
    ...mapActions('admin', [
      'loadUsers'
    ]),
    getUserName (userId) {
      const user = this.users.find(u => u.id === userId)
      return user ? `${user.firstName} ${user.lastName}` || user.email || userId : userId
    },
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    formatDate (date) {
      if (date) {
        return moment(date.toDate()).format('YYYY/MM/DD - HH:mm')
      } else {
        return ''
      }
    },
    handleRowClick (item) {
      const index = this.expanded.indexOf(item)
      if (index === -1) {
        this.expanded = [item]
        if (!item.votesLoaded) {
          this.fetchDetailedSummaryVotes(item.clientId)
        }
      } else {
        this.expanded = []
      }
    }
  },
  computed: {
    ...mapGetters('ai', [
      'detailedSummaryVotes'
    ]),
    ...mapGetters('admin', [
      'users'
    ]),
    headers () {
      return [
        { text: this.$t('views.adminAIReviews.clientId'), value: 'clientId' },
        { text: this.$t('views.adminAIReviews.reviewedSummaries'), value: 'totalSummaries' }
      ]
    },
    subHeaders () {
      return [
        { text: this.$t('views.adminAIReviews.summaryId'), value: 'summaryId' },
        { text: this.$t('views.adminAIReviews.user'), value: 'userId' },
        { text: this.$t('views.adminAIReviews.vote'), value: 'vote' },
        { text: this.$t('views.adminAIReviews.comment'), value: 'comment' },
        { text: this.$t('views.adminAIReviews.timestamp'), value: 'timestamp' }
      ]
    },
    groupedVotes () {
      const grouped = []
      Object.entries(this.detailedSummaryVotes).forEach(([clientId, summaries]) => {
        const votes = []
        Object.entries(summaries).forEach(([summaryId, userVotes]) => {
          Object.entries(userVotes).forEach(([userId, voteData]) => {
            votes.push({
              summaryId,
              userId,
              vote: voteData.vote,
              comment: voteData.comment || '',
              timestamp: this.formatDate(voteData.timestamp)
            })
          })
        })
        grouped.push({
          id: clientId,
          clientId,
          totalSummaries: Object.keys(summaries).length,
          votes,
          votesLoaded: true
        })
      })
      return grouped
    }
  },
  created: function () {
    this.fetchDetailedSummaryVotes()
    if (this.users.length === 0) {
      this.loadUsers()
    }
  }
}
</script>
